import React, { useContext } from 'react';
import CurrentBrandContext from 'contexts/current_brand/context';

export const useCurrentBrand = () => {
  return useContext(CurrentBrandContext);
};
